/* @flow */

import Honeybadger from 'honeybadger-js';

export default function failure<V>(errorMessage: string, fallback: () => V): V {
  const error = new Error(errorMessage);
  if (__DEV__) {
    throw error;
  } else {
    Honeybadger.notify(error);
    return fallback();
  }
}
